import React from 'react';
import Lottie from 'lottie-react';
import LiveIcon from '../../molecules/card-image-headline/lottie-live-icon.json';
import StoryPageLivetvWidget from '../story-page-livetv-widget/story-page-livetv-widget';
import Icon from '@mdi/react';
import { mdiFormatListBulleted } from '@mdi/js';
import { BQLink } from '../../atoms/bqlink';
import './expand-videos-widget.m.css';


const ExpandVideosWidget = ({ story, datalayerFields, mostRead, isLiveBlog }) => {
  return (
    <div styleName="expandVideosWidget">
      <div styleName="live-icon">
        <Lottie animationData={LiveIcon} loop={true} autoplay={true} />
      </div>
      <div styleName="first-row">
        <div styleName="first-row-child1">
          <img src="/images/NDTV-Profit-logo-darkmode.png" alt="ndtv|Profit" />
          <div styleName="static-text">
            <span>Now Available on TV</span>
          </div>
        </div>
        <div>
          <StoryPageLivetvWidget />
        </div>
      </div>
      <div styleName="sv-bottom">
        <BQLink href={`/videos?src=must_watch`} styleName="sv-bottom-text">
          <Icon path={mdiFormatListBulleted} size={1} color="white" />
          <span styleName="sv-bottom-title">All Shows</span>
        </BQLink>
      </div>
    </div>
  );
};

export default ExpandVideosWidget;
